import { AuthService } from '../auth/auth.service';

import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDivider } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [
  CommonModule,
  MatToolbarModule,
  MatButtonModule,
  RouterModule,
  MatCardModule,
  TranslateModule,
];

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [...MODULES, FaIconComponent, MatDivider],
})
export class HomeComponent implements OnInit {
  public auth = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    if (this.auth.authenticated()) {
      const flutterRoute = localStorage.getItem('flutterRoute');
      const route = flutterRoute ? flutterRoute : '/dashboard';
      this.router.navigate([route]);
    } else {
      this.auth.setLanguage();
    }
  }
}
